import { Authenticated, Refine } from "@refinedev/core";
import { RefineKbar, RefineKbarProvider } from "@refinedev/kbar";

import {
  notificationProvider,
  RefineThemes,
  ThemedLayoutV2,
} from "@refinedev/mantine";

import {
  ColorScheme,
  ColorSchemeProvider,
  Global,
  MantineProvider,
} from "@mantine/core";
import { NotificationsProvider } from "@mantine/notifications";
import { useLocalStorage } from "@mantine/hooks";
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
} from "react-router-dom";
import routerBindings, {
  DocumentTitleHandler,
  UnsavedChangesNotifier,
} from "@refinedev/react-router-v6";
import { dataProvider } from "./dataProvider";
import {
  MantineCreateInferencer,
  MantineEditInferencer,
  MantineShowInferencer,
} from "@refinedev/inferencer/mantine";
import authProvider from "./authProvider";
import { LoginPage } from "pages/auth/LoginPage";
import accessControlProvider from "./accessControlProvider";
import axiosInstance from "axiosInstance";
import Header from "components/header";
import Title from "components/header/Title";
import { UserList } from "components/users/List";
import { UserEdit } from "components/users/Edit";
import { UserShow } from "components/users/Show";
import { UserCreate } from "components/users/Create";
import { WaitlistItemList } from "components/waitlist_items/List";
import { GiftCardTemplateList } from "components/gift_card_templates/List";
import { GiftCardTemplateCreate } from "components/gift_card_templates/Create";
import { GiftCardTemplateEdit } from "components/gift_card_templates/Edit";
import { GiftCardTemplateShow } from "components/gift_card_templates/Show";
import { GiftCardList } from "components/gift_cards/List";
import { GiftCardCreate } from "components/gift_cards/Create";
import { GiftCardEdit } from "components/gift_cards/Edit";
import { GiftCardShow } from "components/gift_cards/Show";
import { GiftCardCampaignList } from "components/gift_card_campaigns/List";
import { GiftCardCampaignCreate } from "components/gift_card_campaigns/Create";
import { GiftCardCampaignEdit } from "components/gift_card_campaigns/Edit";
import { GiftCardCampaignShow } from "components/gift_card_campaigns/Show";
import { SurveyList } from "components/surveys/List";
import { SurveyCreate } from "components/surveys/Create";
import { SurveyEdit } from "components/surveys/Edit";
import { SurveyShow } from "components/surveys/Show";
import { ArticleList } from "components/articles/List";
import {
  IconArticle,
  IconBandage,
  IconClock,
  IconCoin,
  IconCoinOff,
  IconCopy,
  IconDashboard,
  IconForms,
  IconGiftCard,
  IconGraph,
  IconPennant,
  IconPennantOff,
  IconPictureInPicture,
  IconSend,
  IconSpeakerphone,
  IconStack,
  IconTag,
  IconTrophy,
  IconUsers,
  IconVaccine,
  IconMessage,
  IconThumbUp,
  IconSettings,
  IconFile,
  IconCreditCard,
  IconFileInvoice,
  IconMug,
  IconCalendarRepeat,
  IconTicket,
  IconMailHeart,
  IconMailboxOff,
  IconMailUp,
  IconMailCode,
  IconStar,
} from "@tabler/icons-react";
import { TierList } from "components/tier/List";
import { TierEdit } from "components/tier/Edit";
import { TierShow } from "components/tier/Show";
import { XpEarningList } from "components/xp_earning /List";
import { XpEarningShow } from "components/xp_earning /Show";
import { XpEarningEdit } from "components/xp_earning /Edit";
import { XpEarningCreate } from "components/xp_earning /Create";
import { UserDetails } from "components/users/show/UserDetails";
import { CoinEarningList } from "components/coin_earning/List";
import { CoinEarningCreate } from "components/coin_earning/Create";
import { CoinEarningEdit } from "components/coin_earning/Edit";
import { CoinEarningShow } from "components/coin_earning/Show";
import { LoyaltyRewardList } from "components/loyalty_reward/List";
import { LoyaltyRewardCreate } from "components/loyalty_reward/Create";
import { LoyaltyRewardShow } from "components/loyalty_reward/Show";
import { LoyaltyRewardEdit } from "components/loyalty_reward/Edit";
import { CoinSpendingList } from "components/coin_spending/List";
import { CoinSpendingCreate } from "components/coin_spending/Create";
import { CoinSpendingShow } from "components/coin_spending/Show";
import { CoinSpendingEdit } from "components/coin_spending/Edit";
import { XpReductionList } from "components/xp_reduction/List";
import { XpReductionCreate } from "components/xp_reduction/Create";
import { XpReductionShow } from "components/xp_reduction/Show";
import { XpReductionEdit } from "components/xp_reduction/Edit";
import Widget from "widget/Widget";
import { ArticleShow } from "components/articles/Show";
import { ArticleEdit } from "components/articles/Edit";
import { ProductSegmentList } from "components/product_segments/List";
import { ProductSegmentCreate } from "components/product_segments/Create";
import { ProductSegmentEdit } from "components/product_segments/Edit";
import { ProductSegmentShow } from "components/product_segments/Show";
import { CategoryList } from "components/categories/List";
import { CategoryCreate } from "components/categories/Create";
import { CategoryEdit } from "components/categories/Edit";
import { CategoryShow } from "components/categories/Show";
import Dashboard from "components/dashboards/Dashboard";
import { SaleAnnouncementList } from "components/sale_announcements/List";
import { SaleAnnouncementCreate } from "components/sale_announcements/Create";
import { SaleAnnouncementEdit } from "components/sale_announcements/Edit";
import { SaleAnnouncementShow } from "components/sale_announcements/Show";
import { CoinEarningRewardList } from "components/coin_earning_rewards/List";
import { CoinEarningRewardShow } from "components/coin_earning_rewards/Show";
import { CoinEarningRewardEdit } from "components/coin_earning_rewards/Edit";
import { PollList } from "components/polls/List";
import { PollCreate } from "components/polls/Create";
import { PollShow } from "components/polls/Show";
import { PollEdit } from "components/polls/Edit";
import { PollOptionCreate } from "components/poll_options/Create";
import { PollOptionShow } from "components/poll_options/Show";
import { PollOptionEdit } from "components/poll_options/Edit";
import { CommentList } from "components/comments/List";
import { CommentShow } from "components/comments/Show";
import { CommentCreate } from "components/comments/Create";
import { CommentEdit } from "components/comments/Edit";
import { LikeCreate } from "components/like/Create";
import { LikeList } from "components/like/List";
import { LikeEdit } from "components/like/Edit";
import { LikeShow } from "components/like/Show";
import { PlanList } from "components/plans/List";
import { PlanShow } from "components/plans/Show";
import { SubscriptionList } from "components/subscriptions/List";
import { SubscriptionShow } from "components/subscriptions/Show";
import { InvoiceList } from "components/invoices/List";
import { InvoiceShow } from "components/invoices/Show";
import { SanityCheckersList } from "components/sanity_checkers/List";
import { SanityCheckersShow } from "components/sanity_checkers/Show";
import { SanityCheckersEdit } from "components/sanity_checkers/Edit";
import { LoginActivities } from "components/users/show/LoginActivities";
import { PublicSiteSettingsList } from "components/public_site_settings/List";
import { ModalsProvider } from "@mantine/modals";
import { TeaAddonSubscriptionList } from "components/tea_addon_subscriptions/List";
import { TeaAddonSubscriptionShow } from "components/tea_addon_subscriptions/Show";
import { TeaAddonList } from "components/tea_addons/List";
import { TeaAddonShow } from "components/tea_addons/Show";
import { TeaAddonSubscriptionEdit } from "components/tea_addon_subscriptions/Edit";
import { TeaAddonEdit } from "components/tea_addons/Edit";
import { TeaAddonRenewalRunList } from "components/tea_addon_renewal_runs/List";
import { TeaAddonRenewalRunShow } from "components/tea_addon_renewal_runs/Show";
import { TeaAddonRenewalRunEdit } from "components/tea_addon_renewal_runs/Edit";
import { TeaAddonRenewalRunCreate } from "components/tea_addon_renewal_runs/Create";
import { TeaAddonSubscriptionDashboard } from "components/tea_addon_subscriptions/Dashboard";
import { IconRefreshDot } from "@tabler/icons";
import { ZendeskList } from "components/zendesk/List";
import { ZendeskShow } from "components/zendesk/Show";
import { ReviewRequestBlacklistList } from "components/review_request_blacklists/List";
import { ReviewRequestBlacklistCreate } from "components/review_request_blacklists/Create";
import { ReviewRequestBlacklistShow } from "components/review_request_blacklists/Show";
import { ReviewRequestList } from "components/review_requests/List";
import { ReviewRequestShow } from "components/review_requests/Show";
import { ReviewRequestEdit } from "components/review_requests/Edit";
import { ReviewList } from "components/reviews/List";
import { ReviewShow } from "components/reviews/Show";
import { ReviewRequestAnalytics } from "components/review_request_system/Analytics";
import { ReviewRequestSettings } from "components/review_request_system/Settings";
import { ReviewEmailTemplateList } from "components/review_email_templates/List";
import { ReviewEmailTemplateEdit } from "components/review_email_templates/Edit";
import { CancellationReasonList } from "components/cancel_flow/CancellationReasonList";
import { CancellationReasonCreate } from "components/cancel_flow/CancellationReasonCreate";
import { CancellationReasonEdit } from "components/cancel_flow/CancellationReasonEdit";
import { OfferConfigurationList } from "components/cancel_flow/OfferConfigurationList";
import { OfferConfigurationCreate } from "components/cancel_flow/OfferConfigurationCreate";
import { OfferConfigurationEdit } from "components/cancel_flow/OfferConfigurationEdit";
import { CancelSessionList } from "components/cancel_flow/CancelSessionList";
import { CancelSessionShow } from "components/cancel_flow/CancelSessionShow";
import { CancelFlowDashboard } from "components/cancel_flow/CancelFlowDashboard";
import { CancelFlowReport } from "components/cancel_flow/CancelFlowReport";
import { CancelPeopleList } from "components/cancel_flow/CancelPeopleList";
import { CancelPeopleShow } from "components/cancel_flow/CancelPeopleShow";
import {
  IconDoorExit,
  IconListDetails,
  IconPercentage,
  IconChartBar,
  IconReportAnalytics,
  IconUsersGroup,
  IconShieldCheck,
} from "@tabler/icons-react";
import { RolePermissionsList } from "components/role_permissions/List";

function App() {
  const [colorScheme, setColorScheme] = useLocalStorage<ColorScheme>({
    key: "mantine-color-scheme",
    defaultValue: "light",
    getInitialValueInEffect: true,
  });

  const toggleColorScheme = (value?: ColorScheme) =>
    setColorScheme(value || (colorScheme === "dark" ? "light" : "dark"));

  return (
    <BrowserRouter>
      <RefineKbarProvider>
        <ColorSchemeProvider
          colorScheme={colorScheme}
          toggleColorScheme={toggleColorScheme}
        >
          {/* You can change the theme colors here. example: theme={{ ...RefineThemes.Magenta, colorScheme:colorScheme }} */}
          <MantineProvider
            theme={{ ...RefineThemes.Blue, colorScheme: colorScheme }}
            withNormalizeCSS
            withGlobalStyles
          >
            <ModalsProvider>
              <Global styles={{ body: { WebkitFontSmoothing: "auto" } }} />
              <NotificationsProvider position="top-right">
                <Refine
                  notificationProvider={notificationProvider}
                  routerProvider={routerBindings}
                  dataProvider={dataProvider(
                    `${process.env.REACT_APP_CP_API_URL}/api/admin`,
                    axiosInstance,
                  )}
                  authProvider={authProvider}
                  accessControlProvider={accessControlProvider}
                  options={{
                    syncWithLocation: true,
                    warnWhenUnsavedChanges: true,
                    projectId: "uS6qCn-hrhIyI-XTgEHu",
                  }}
                  resources={[
                    {
                      name: "Dashboard",
                      identifier: "dashboard",
                      list: "/",
                      meta: {
                        canDelete: true,
                        icon: <IconDashboard />,
                      },
                    },
                    {
                      name: "users",
                      list: "/users",
                      create: "/users/create",
                      edit: "/users/edit/:id",
                      show: "/users/show/:id",
                      meta: {
                        canDelete: true,
                        icon: <IconUsers />,
                      },
                    },
                    {
                      name: "gift_cards_section",
                      meta: {
                        icon: <IconGiftCard />,
                        label: "Gift cards",
                      },
                    },
                    {
                      name: "gift_card_templates",
                      list: "/gift_card_templates",
                      create: "/gift_card_templates/create",
                      edit: "/gift_card_templates/edit/:id",
                      show: "/gift_card_templates/show/:id",
                      meta: {
                        canDelete: true,
                        icon: <IconCopy />,
                        parent: "gift_cards_section",
                      },
                    },
                    {
                      name: "gift_cards",
                      list: "/gift_cards",
                      create: "/gift_cards/create",
                      edit: "/gift_cards/edit/:id",
                      show: "/gift_cards/show/:id",
                      meta: {
                        canDelete: true,
                        icon: <IconGiftCard />,
                        parent: "gift_cards_section",
                      },
                    },
                    {
                      name: "gift_card_campaigns",
                      list: "/gift_card_campaigns",
                      create: "/gift_card_campaigns/create",
                      edit: "/gift_card_campaigns/edit/:id",
                      show: "/gift_card_campaigns/show/:id",
                      meta: {
                        canDelete: true,
                        icon: <IconSend />,
                        parent: "gift_cards_section",
                      },
                    },
                    {
                      name: "waitlist_items",
                      list: "/waitlist_items",
                      create: "/waitlist_items/create",
                      edit: "/waitlist_items/edit/:id",
                      show: "/waitlist_items/show/:id",
                      meta: { canDelete: true, icon: <IconClock /> },
                    },
                    {
                      name: "surveys_section",
                      meta: { icon: <IconForms />, label: "Surveys" },
                    },
                    {
                      name: "surveys",
                      list: "/surveys",
                      create: "/surveys/create",
                      edit: "/surveys/edit/:id",
                      show: "/surveys/show/:id",
                      meta: {
                        canDelete: true,
                        icon: <IconForms />,
                        parent: "surveys_section",
                      },
                    },
                    {
                      name: "survey_rewards",
                      list: "/surveys/rewards",
                      create: "/surveys/rewards/create",
                      edit: "/surveys/rewards/edit/:id",
                      show: "/surveys/rewards/show/:id",
                      meta: {
                        canDelete: true,
                        icon: <IconTrophy />,
                        parent: "surveys_section",
                      },
                    },
                    {
                      name: "loyalty_section",
                      meta: { icon: <IconCoin />, label: "Loyalty" },
                    },
                    {
                      name: "tiers",
                      list: "/tiers",
                      edit: "/tiers/edit/:id",
                      show: "/tiers/show/:id",
                      meta: {
                        canDelete: false,
                        icon: <IconStack />,
                        parent: "loyalty_section",
                      },
                    },
                    {
                      name: "xp_earnings",
                      list: "/xp_earnings",
                      create: "/xp_earnings/create",
                      edit: "/xp_earnings/edit/:id",
                      show: "/xp_earnings/show/:id",
                      meta: {
                        canDelete: false,
                        icon: <IconPennant />,
                        parent: "loyalty_section",
                      },
                    },
                    {
                      name: "xp_reductions",
                      list: "/xp_reductions",
                      create: "/xp_reductions/create",
                      edit: "/xp_reductions/edit/:id",
                      show: "/xp_reductions/show/:id",
                      meta: {
                        canDelete: false,
                        icon: <IconPennantOff />,
                        parent: "loyalty_section",
                      },
                    },
                    {
                      name: "loyalty_rewards",
                      list: "/loyalty_rewards",
                      create: "/loyalty_rewards/create",
                      edit: "/loyalty_rewards/edit/:id",
                      show: "/loyalty_rewards/show/:id",
                      meta: {
                        canDelete: false,
                        icon: <IconTrophy />,
                        parent: "loyalty_section",
                      },
                    },
                    {
                      name: "coin_earning_rewards",
                      list: "/coin_earning_rewards",
                      edit: "/coin_earning_rewards/edit/:id",
                      show: "/coin_earning_rewards/show/:id",
                      meta: {
                        canDelete: false,
                        icon: <IconCoin />,
                        parent: "loyalty_section",
                      },
                    },
                    {
                      name: "coin_earnings",
                      list: "/coin_earnings",
                      create: "/coin_earnings/create",
                      edit: "/coin_earnings/edit/:id",
                      show: "/coin_earnings/show/:id",
                      meta: {
                        canDelete: false,
                        icon: <IconCoin />,
                        parent: "loyalty_section",
                      },
                    },
                    {
                      name: "coin_spendings",
                      list: "/coin_spendings",
                      create: "/coin_spendings/create",
                      edit: "/coin_spendings/edit/:id",
                      show: "/coin_spendings/show/:id",
                      meta: {
                        canDelete: false,
                        icon: <IconCoinOff />,
                        parent: "loyalty_section",
                      },
                    },
                    {
                      name: "widget",
                      list: "/widget",
                      meta: {
                        canDelete: false,
                        icon: <IconPictureInPicture />,
                        parent: "loyalty_section",
                      },
                    },
                    {
                      name: "articles_section",
                      meta: { icon: <IconArticle />, label: "Articles" },
                    },
                    {
                      name: "articles",
                      list: "/articles",
                      create: "/articles/create",
                      edit: "/articles/edit/:id",
                      show: "/articles/show/:id",
                      meta: {
                        canDelete: true,
                        icon: <IconArticle />,
                        parent: "articles_section",
                      },
                    },
                    {
                      name: "product_segments",
                      list: "/product_segments",
                      create: "/product_segments/create",
                      edit: "/product_segments/edit/:id",
                      show: "/product_segments/show/:id",
                      meta: {
                        canDelete: true,
                        icon: <IconVaccine />,
                        parent: "articles_section",
                      },
                    },
                    {
                      name: "categories",
                      list: "/categories",
                      create: "/categories/create",
                      edit: "/categories/edit/:id",
                      show: "/categories/show/:id",
                      meta: {
                        canDelete: true,
                        icon: <IconTag />,
                        parent: "articles_section",
                      },
                    },
                    {
                      name: "sale_announcements",
                      list: "/sale_announcements",
                      create: "/sale_announcements/create",
                      edit: "/sale_announcements/edit/:id",
                      show: "/sale_announcements/show/:id",
                      meta: {
                        canDelete: true,
                        icon: <IconSpeakerphone />,
                      },
                    },
                    {
                      name: "polls",
                      list: "/polls",
                      create: "/polls/create",
                      edit: "/polls/edit/:id",
                      show: "/polls/show/:id",
                      meta: {
                        canDelete: true,
                        icon: <IconGraph />,
                      },
                    },
                    {
                      name: "poll_options",
                      list: "/poll_options",
                      create: "/poll_options/create/:poll_id",
                      edit: "/poll_options/edit/:id",
                      show: "/poll_options/show/:id",
                      meta: {
                        canDelete: true,
                        icon: <IconGraph />,
                        hide: true,
                      },
                    },
                    {
                      name: "poll_answers",
                      list: "/poll_answers",
                      meta: {
                        canDelete: true,
                        icon: <IconGraph />,
                        hide: true,
                      },
                    },
                    {
                      name: "comments",
                      list: "/comments",
                      create: "/comments/create",
                      edit: "/comments/edit/:id",
                      show: "/comments/show/:id",
                      meta: {
                        canDelete: true,
                        icon: <IconMessage />,
                      },
                    },
                    {
                      name: "likes",
                      list: "/likes",
                      create: "/likes/create",
                      edit: "/likes/edit/:id",
                      show: "/likes/show/:id",
                      meta: {
                        canDelete: true,
                        icon: <IconThumbUp />,
                      },
                    },
                    {
                      name: "sanity_checkers",
                      list: "/sanity_checkers",
                      create: "/sanity_checkers/create",
                      edit: "/sanity_checkers/edit/:id",
                      show: "/sanity_checkers/show/:id",
                      meta: {
                        canDelete: true,
                        icon: <IconBandage />,
                      },
                    },
                    {
                      name: "plans",
                      list: "/plans",
                      create: "/plans/create",
                      edit: "/plans/edit/:id",
                      show: "/plans/show/:id",
                      meta: {
                        canDelete: true,
                        icon: <IconFile />,
                      },
                    },
                    {
                      name: "subscriptions",
                      list: "/subscriptions",
                      show: "/subscriptions/show/:id",
                      meta: {
                        canDelete: false,
                        icon: <IconCreditCard />,
                      },
                    },
                    {
                      name: "invoices",
                      list: "/invoices",
                      show: "/invoices/show/:id",
                      meta: {
                        canDelete: false,
                        icon: <IconFileInvoice />,
                      },
                    },
                    {
                      name: "tea_addons_section",
                      meta: {
                        icon: <IconMug />,
                        label: "Tea Addons",
                      },
                    },
                    {
                      name: "tea_addon_subscriptions",
                      list: "/tea_addon_subscriptions",
                      show: "/tea_addon_subscriptions/show/:id",
                      create: "/tea_addon_subscriptions/create",
                      edit: "/tea_addon_subscriptions/edit/:id",
                      meta: {
                        canDelete: false,
                        icon: <IconRefreshDot />,
                        parent: "tea_addons_section",
                      },
                    },
                    {
                      name: "tea_addon_subscription_analytics",
                      list: "/tea_addon_subscriptions/analytics",
                      meta: {
                        canDelete: false,
                        icon: <IconGraph />,
                        parent: "tea_addons_section",
                        label: "Subscription Analytics",
                      },
                    },
                    {
                      name: "tea_addons",
                      list: "/tea_addons",
                      show: "/tea_addons/show/:id",
                      create: "/tea_addons/create",
                      edit: "/tea_addons/edit/:id",
                      meta: {
                        canDelete: false,
                        icon: <IconMug />,
                        parent: "tea_addons_section",
                      },
                    },
                    {
                      name: "tea_addon_renewal_runs",
                      list: "/tea_addon_renewal_runs",
                      show: "/tea_addon_renewal_runs/show/:id",
                      create: "/tea_addon_renewal_runs/create",
                      edit: "/tea_addon_renewal_runs/edit/:id",
                      meta: {
                        canDelete: false,
                        icon: <IconCalendarRepeat />,
                        parent: "tea_addons_section",
                      },
                    },
                    {
                      name: "public_site_settings",
                      list: "/public_site_settings",
                      meta: {
                        canDelete: false,
                        icon: <IconSettings />,
                      },
                    },
                    {
                      name: "zendesk",
                      list: "/zendesk",
                      meta: {
                        canDelete: false,
                        icon: <IconTicket />,
                      },
                    },
                    {
                      name: "review_request_system_section",
                      meta: {
                        icon: <IconMailUp />,
                        label: "Review Request System",
                      },
                    },
                    {
                      name: "review_request_analytics",
                      list: "/review_request_analytics",
                      meta: {
                        icon: <IconGraph />,
                        label: "Analytics",
                        parent: "review_request_system_section",
                      },
                    },
                    {
                      name: "review_requests",
                      list: "/review_requests",
                      edit: "/review_requests/edit/:id",
                      show: "/review_requests/show/:id",
                      meta: {
                        icon: <IconMailHeart />,
                        parent: "review_request_system_section",
                      },
                    },
                    {
                      name: "reviews",
                      list: "/reviews",
                      show: "/reviews/show/:id",
                      meta: {
                        icon: <IconStar />,
                        label: "Reviews",
                        parent: "review_request_system_section",
                      },
                    },
                    {
                      name: "review_request_blacklists",
                      list: "/review_request_blacklists",
                      create: "/review_request_blacklists/create",
                      show: "/review_request_blacklists/show/:id",
                      meta: {
                        canDelete: true,
                        icon: <IconMailboxOff />,
                        label: "Blacklist",
                        parent: "review_request_system_section",
                      },
                    },
                    {
                      name: "review_request_settings",
                      list: "/review_request_settings",
                      meta: {
                        icon: <IconSettings />,
                        label: "Settings",
                        parent: "review_request_system_section",
                      },
                    },
                    {
                      name: "review_email_templates",
                      list: "/review_email_templates",
                      edit: "/review_email_templates/edit/:id",
                      meta: {
                        icon: <IconMailCode />,
                        label: "Email Templates",
                        parent: "review_request_system_section",
                      },
                    },
                    {
                      name: "cancel_flow_section",
                      meta: {
                        icon: <IconDoorExit />,
                        label: "Cancel Flow",
                      },
                    },
                    {
                      name: "cancel_dashboard",
                      list: "/cancel_dashboard",
                      meta: {
                        canDelete: false,
                        icon: <IconChartBar />,
                        parent: "cancel_flow_section",
                        label: "Dashboard",
                      },
                    },
                    {
                      name: "offer_configurations",
                      list: "/offer_configurations",
                      create: "/offer_configurations/create",
                      edit: "/offer_configurations/edit/:id",
                      meta: {
                        canDelete: true,
                        icon: <IconPercentage />,
                        parent: "cancel_flow_section",
                      },
                    },
                    {
                      name: "cancellation_reasons",
                      list: "/cancellation_reasons",
                      create: "/cancellation_reasons/create",
                      edit: "/cancellation_reasons/edit/:id",
                      meta: {
                        canDelete: true,
                        icon: <IconListDetails />,
                        parent: "cancel_flow_section",
                      },
                    },
                    {
                      name: "cancel_sessions",
                      list: "/cancel_sessions",
                      show: "/cancel_sessions/show/:id",
                      meta: {
                        canDelete: false,
                        icon: <IconDoorExit />,
                        parent: "cancel_flow_section",
                      },
                    },
                    {
                      name: "cancel_reports",
                      list: "/cancel_reports",
                      meta: {
                        canDelete: false,
                        icon: <IconReportAnalytics />,
                        parent: "cancel_flow_section",
                        label: "Reports",
                      },
                    },
                    {
                      name: "cancel_people",
                      list: "/cancel_people",
                      show: "/cancel_people/show/:id",
                      meta: {
                        canDelete: false,
                        icon: <IconUsersGroup />,
                        parent: "cancel_flow_section",
                        label: "People",
                      },
                    },
                    {
                      name: "loyalty_order_problems",
                      list: "/survey_checkers/:sanity_checker_id/loyalty_order_problems",
                      edit: "/sanity_checkers/:sanity_checker_id/loyalty_order_problems/edit/:id",
                      show: "/sanity_checkers/:sanity_checker_id/show/:id",
                      meta: {
                        canDelete: true,
                        icon: <IconBandage />,
                        hide: true,
                      },
                    },
                    {
                      name: "role_permissions",
                      list: "/role_permissions",
                      meta: {
                        canDelete: false,
                        icon: <IconShieldCheck />,
                        label: "Menu Permissions",
                      },
                    },
                  ]}
                >
                  <Routes>
                    <Route
                      element={
                        <Authenticated>
                          <ThemedLayoutV2 Title={Title} Header={Header}>
                            <Outlet />
                          </ThemedLayoutV2>
                        </Authenticated>
                      }
                    >
                      <Route path="/">
                        <Route index element={<Dashboard />} />
                      </Route>
                      <Route path="/users">
                        <Route index element={<UserList />} />
                        <Route path="create" element={<UserCreate />} />
                        <Route path="edit/:id" element={<UserEdit />} />
                        <Route path="show/:id" element={<UserShow />}>
                          <Route index element={<Navigate to="details" />} />
                          <Route path="details" element={<UserDetails />} />
                          <Route
                            path="xp_earnings"
                            element={<XpEarningList />}
                          />
                          <Route
                            path="login_activities"
                            element={<LoginActivities />}
                          />
                          <Route
                            path="coin_earnings"
                            element={<CoinEarningList />}
                          />
                          <Route
                            path="coin_spendings"
                            element={<CoinSpendingList />}
                          />
                          <Route
                            path="xp_reductions"
                            element={<XpReductionList />}
                          />
                        </Route>
                      </Route>
                      <Route path="/gift_card_templates">
                        <Route index element={<GiftCardTemplateList />} />
                        <Route
                          path="create"
                          element={<GiftCardTemplateCreate />}
                        />
                        <Route
                          path="edit/:id"
                          element={<GiftCardTemplateEdit />}
                        />
                        <Route
                          path="show/:id"
                          element={<GiftCardTemplateShow />}
                        />
                      </Route>
                      <Route path="/gift_cards">
                        <Route index element={<GiftCardList />} />
                        <Route path="create" element={<GiftCardCreate />} />
                        <Route path="edit/:id" element={<GiftCardEdit />} />
                        <Route path="show/:id" element={<GiftCardShow />} />
                      </Route>
                      <Route path="/gift_card_campaigns">
                        <Route index element={<GiftCardCampaignList />} />
                        <Route
                          path="create"
                          element={<GiftCardCampaignCreate />}
                        />
                        <Route
                          path="edit/:id"
                          element={<GiftCardCampaignEdit />}
                        />
                        <Route
                          path="show/:id"
                          element={<GiftCardCampaignShow />}
                        />
                      </Route>
                      <Route path="/surveys">
                        <Route index element={<SurveyList />} />
                        <Route path="create" element={<SurveyCreate />} />
                        <Route path="edit/:id" element={<SurveyEdit />} />
                        <Route path="show/:id" element={<SurveyShow />} />
                        <Route path="rewards">
                          <Route index element={<div />} />
                        </Route>
                      </Route>
                      <Route path="/tiers">
                        <Route index element={<TierList />} />
                        <Route path="edit/:id" element={<TierEdit />} />
                        <Route path="show/:id" element={<TierShow />} />
                      </Route>
                      <Route path="xp_earnings">
                        <Route index element={<XpEarningList />} />
                        <Route path="show/:id" element={<XpEarningShow />} />
                        <Route path="edit/:id" element={<XpEarningEdit />} />
                        <Route path="create" element={<XpEarningCreate />} />
                      </Route>
                      <Route path="coin_earning_rewards">
                        <Route index element={<CoinEarningRewardList />} />
                        <Route
                          path="show/:id"
                          element={<CoinEarningRewardShow />}
                        />
                        <Route
                          path="edit/:id"
                          element={<CoinEarningRewardEdit />}
                        />
                      </Route>
                      <Route path="coin_earnings">
                        <Route index element={<CoinEarningList />} />
                        <Route path="show/:id" element={<CoinEarningShow />} />
                        <Route path="edit/:id" element={<CoinEarningEdit />} />
                        <Route path="create" element={<CoinEarningCreate />} />
                      </Route>
                      <Route path="loyalty_rewards">
                        <Route index element={<LoyaltyRewardList />} />
                        <Route
                          path="show/:id"
                          element={<LoyaltyRewardShow />}
                        />
                        <Route
                          path="edit/:id"
                          element={<LoyaltyRewardEdit />}
                        />
                        <Route
                          path="create"
                          element={<LoyaltyRewardCreate />}
                        />
                      </Route>
                      <Route path="coin_spendings">
                        <Route index element={<CoinSpendingList />} />
                        <Route path="show/:id" element={<CoinSpendingShow />} />
                        <Route path="edit/:id" element={<CoinSpendingEdit />} />
                        <Route path="create" element={<CoinSpendingCreate />} />
                      </Route>
                      <Route path="xp_reductions">
                        <Route index element={<XpReductionList />} />
                        <Route path="show/:id" element={<XpReductionShow />} />
                        <Route path="edit/:id" element={<XpReductionEdit />} />
                        <Route path="create" element={<XpReductionCreate />} />
                      </Route>
                      <Route path="/articles">
                        <Route index element={<ArticleList />} />
                        <Route path="edit/:id" element={<ArticleEdit />} />
                        <Route path="show/:id" element={<ArticleShow />} />
                      </Route>
                      <Route path="/product_segments">
                        <Route index element={<ProductSegmentList />} />
                        <Route
                          path="create"
                          element={<ProductSegmentCreate />}
                        />
                        <Route
                          path="edit/:id"
                          element={<ProductSegmentEdit />}
                        />
                        <Route
                          path="show/:id"
                          element={<ProductSegmentShow />}
                        />
                      </Route>
                      <Route path="/categories">
                        <Route index element={<CategoryList />} />
                        <Route path="create" element={<CategoryCreate />} />
                        <Route path="edit/:id" element={<CategoryEdit />} />
                        <Route path="show/:id" element={<CategoryShow />} />
                      </Route>
                      <Route path="/sale_announcements">
                        <Route index element={<SaleAnnouncementList />} />
                        <Route
                          path="create"
                          element={<SaleAnnouncementCreate />}
                        />
                        <Route
                          path="edit/:id"
                          element={<SaleAnnouncementEdit />}
                        />
                        <Route
                          path="show/:id"
                          element={<SaleAnnouncementShow />}
                        />
                      </Route>
                      <Route path="/poll_options">
                        <Route
                          path="create/:poll_id"
                          element={<PollOptionCreate />}
                        />
                        <Route path="show/:id" element={<PollOptionShow />} />
                        <Route path="edit/:id" element={<PollOptionEdit />} />
                      </Route>
                      <Route path="/polls">
                        <Route index element={<PollList />} />
                        <Route path="create" element={<PollCreate />} />
                        <Route path="show/:id" element={<PollShow />} />
                        <Route path="edit/:id" element={<PollEdit />} />
                      </Route>
                      <Route path="/comments">
                        <Route index element={<CommentList />} />
                        <Route path="create" element={<CommentCreate />} />
                        <Route path="edit/:id" element={<CommentEdit />} />
                        <Route path="show/:id" element={<CommentShow />} />
                      </Route>
                      <Route path="/likes">
                        <Route index element={<LikeList />} />
                        <Route path="create" element={<LikeCreate />} />
                        <Route path="edit/:id" element={<LikeEdit />} />
                        <Route path="show/:id" element={<LikeShow />} />
                      </Route>
                      <Route path="/waitlist_items">
                        <Route index element={<WaitlistItemList />} />
                        <Route
                          path="create"
                          element={<MantineCreateInferencer />}
                        />
                        <Route
                          path="edit/:id"
                          element={<MantineEditInferencer />}
                        />
                        <Route
                          path="show/:id"
                          element={<MantineShowInferencer />}
                        />
                      </Route>
                      <Route path="/sanity_checkers">
                        <Route index element={<SanityCheckersList />} />
                        <Route
                          path="show/:id"
                          element={<SanityCheckersShow />}
                        />
                        <Route
                          path="edit/:id"
                          element={<SanityCheckersEdit />}
                        />
                      </Route>
                      <Route path="/plans">
                        <Route index element={<PlanList />} />
                        <Route path="show/:id" element={<PlanShow />} />
                      </Route>
                      <Route path="/subscriptions">
                        <Route index element={<SubscriptionList />} />
                        <Route path="show/:id" element={<SubscriptionShow />} />
                      </Route>
                      <Route path="/invoices">
                        <Route index element={<InvoiceList />} />
                        <Route path="show/:id" element={<InvoiceShow />} />
                      </Route>
                      <Route path="/tea_addon_subscriptions">
                        <Route index element={<TeaAddonSubscriptionList />} />
                        <Route
                          path="analytics"
                          element={<TeaAddonSubscriptionDashboard />}
                        />
                        <Route
                          path="show/:id"
                          element={<TeaAddonSubscriptionShow />}
                        />
                        <Route
                          path="edit/:id"
                          element={<TeaAddonSubscriptionEdit />}
                        />
                      </Route>
                      <Route path="/tea_addons">
                        <Route index element={<TeaAddonList />} />
                        <Route path="show/:id" element={<TeaAddonShow />} />
                        <Route path="edit/:id" element={<TeaAddonEdit />} />
                      </Route>
                      <Route path="/tea_addon_renewal_runs">
                        <Route index element={<TeaAddonRenewalRunList />} />
                        <Route
                          path="show/:id"
                          element={<TeaAddonRenewalRunShow />}
                        />
                        <Route
                          path="edit/:id"
                          element={<TeaAddonRenewalRunEdit />}
                        />
                        <Route
                          path="create"
                          element={<TeaAddonRenewalRunCreate />}
                        />
                      </Route>
                      <Route path="/cancellation_reasons">
                        <Route index element={<CancellationReasonList />} />
                        <Route
                          path="create"
                          element={<CancellationReasonCreate />}
                        />
                        <Route
                          path="edit/:id"
                          element={<CancellationReasonEdit />}
                        />
                      </Route>
                      <Route path="/offer_configurations">
                        <Route index element={<OfferConfigurationList />} />
                        <Route
                          path="create"
                          element={<OfferConfigurationCreate />}
                        />
                        <Route
                          path="edit/:id"
                          element={<OfferConfigurationEdit />}
                        />
                      </Route>
                      <Route path="/cancel_sessions">
                        <Route index element={<CancelSessionList />} />
                        <Route
                          path="show/:id"
                          element={<CancelSessionShow />}
                        />
                      </Route>
                      <Route path="/cancel_dashboard">
                        <Route index element={<CancelFlowDashboard />} />
                      </Route>
                      <Route path="/cancel_reports">
                        <Route index element={<CancelFlowReport />} />
                      </Route>
                      <Route path="/cancel_people">
                        <Route index element={<CancelPeopleList />} />
                        <Route path="show/:id" element={<CancelPeopleShow />} />
                      </Route>
                      <Route path="/public_site_settings">
                        <Route index element={<PublicSiteSettingsList />} />
                      </Route>
                      <Route path="/zendesk">
                        <Route index element={<ZendeskList />} />
                      </Route>
                      <Route path="/zendesk/tickets/:id/comments">
                        <Route index element={<ZendeskShow />} />
                      </Route>
                      <Route path="/review_request_analytics">
                        <Route index element={<ReviewRequestAnalytics />} />
                      </Route>
                      <Route path="/review_requests">
                        <Route index element={<ReviewRequestList />} />
                        <Route path="edit/:id" element={<ReviewRequestEdit />} />
                        <Route path="show/:id" element={<ReviewRequestShow />} />
                      </Route>
                      <Route path="/reviews">
                        <Route index element={<ReviewList />} />
                        <Route path="show/:id" element={<ReviewShow />} />
                      </Route>
                      <Route path="/review_request_blacklists">
                        <Route
                          index
                          element={<ReviewRequestBlacklistList />}
                        />
                        <Route
                          path="create"
                          element={<ReviewRequestBlacklistCreate />}
                        />
                        <Route
                          path="show/:id"
                          element={<ReviewRequestBlacklistShow />}
                        />
                      </Route>
                      <Route path="/review_request_settings">
                        <Route index element={<ReviewRequestSettings />} />
                      </Route>
                      <Route path="/review_email_templates">
                        <Route index element={<ReviewEmailTemplateList />} />
                        <Route
                          path="edit/:id"
                          element={<ReviewEmailTemplateEdit />}
                        />
                      </Route>
                      <Route path="/widget" element={<Widget />} />
                      <Route path="/role_permissions">
                        <Route index element={<RolePermissionsList />} />
                      </Route>
                    </Route>
                    <Route path="/login" element={<LoginPage />} />
                  </Routes>
                  <RefineKbar />
                  <UnsavedChangesNotifier />
                  <DocumentTitleHandler />
                </Refine>
              </NotificationsProvider>
            </ModalsProvider>
          </MantineProvider>
        </ColorSchemeProvider>
      </RefineKbarProvider>
    </BrowserRouter>
  );
}

export default App;
